import styled from 'styled-components';
export const Centered = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
